import React, { Component } from "react";

export class DefaultHeader extends Component {
  render() {
    const { banner, petShop } = this.props;
    return (
      <div className="row w-100">
        <div className="col-12 text-center">
          <img
            src={
              banner ? banner : process.env.REACT_APP_S3_PATH + "/" + petShop.logo_path
            }
            alt=""
            className="m-height-48 m-width-250"
          />
        </div>
        <div className="col-12 text-center">
          <h4 className="mb-0">{petShop.title}</h4>
        </div>
        <div className="col-12 text-center">
          <h6 className="mb-0 mt-0" style={{ fontSize: "10px" }}>
            {petShop.address}, {petShop.country}
          </h6>
        </div>
        <div className="col-12 text-center">
          <h6 className="mt-0 mb-1" style={{ fontSize: "10px" }}>
            T: {petShop.phone_number} | E: {petShop.email} | W:{" "}
            {petShop.website}
          </h6>
        </div>
        <div className="col-12 text-center">
          <hr style={{ marginBottom: "2px", marginTop: "2px" }} />
        </div>
      </div>
    );
  }
}
